export enum RiskStudyDocumentType {
  BANK_STATEMENT = 'BANK_STATEMENT',
  CHAMBER_OF_COMMERCE = 'CHAMBER_OF_COMMERCE',
  DNI = 'DNI',
  EMPLOYMENT_CERTIFICATION = 'EMPLOYMENT_CERTIFICATION',
  INCOME_CERTIFICATION = 'INCOME_CERTIFICATION',
  PENSION_CERTIFICATION = 'PENSION_CERTIFICATION',
  RENT_DECLARATION = 'RENT_DECLARATION',
  RUT = 'RUT',
  SIGNED_FINANCIAL_STATUS = 'SIGNED_FINANCIAL_STATUS',
}
